const SERVICE_BOOK_BASE = "https://ungapchat5674.cerebralzip.com/api/v1";

// Fetch all persons and combine parallel arrays into structured list
export async function fetchServiceBookPersons() {
  const res = await fetch(`${SERVICE_BOOK_BASE}/chat_pii_get_all_persons`);
  if (!res.ok) throw new Error("Failed to fetch persons");
  const data = await res.json();

  const persons = data.persons || [];
  const employeeIds = data.employee_ids || [];
  const sevarthIds = data.sevarth_ids || [];

  return persons.map((name, i) => ({
    person_name: name,
    employee_id: employeeIds[i] || "",
    sevarth_id: sevarthIds[i] || "",
  }));
}

// Stream response from PII retriever API
export async function streamServiceBookResponse({
  message,
  chatSessionId,
  selectedPerson,
  setChatMessages,
}) {
  const url = `${SERVICE_BOOK_BASE}/chat_pii_retriever/${encodeURIComponent(
    chatSessionId || "default"
  )}`;

  const payload = {
    data: {
      messages: [{ role: "user", content: message, metadata: {} }],
    },
    request: {
      person_name: selectedPerson?.person_name || "",
      employee_id: selectedPerson?.employee_id || "",
      sevarth_id: selectedPerson?.sevarth_id || "",
      use_vector: true,
      k: 20,
      top_n: 10,
    },
  };

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.body) throw new Error("ReadableStream not supported");

  const reader = res.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  let contextArray = [];
  let currentAnswer = "";
  let startedStreaming = false;

  const processLine = (line) => {
    const trimmed = line.trim();
    if (!trimmed) return;

    // Context/sources line (prefix 8:)
    if (trimmed.startsWith("8:")) {
      try {
        const jsonStr = trimmed.substring(2).trim();
        contextArray = JSON.parse(jsonStr);
      } catch {
        // Partial context, wait for more data
      }
      return;
    }

    // Streamed text chunk (prefix 0:)
    if (trimmed.startsWith("0:")) {
      const val = trimmed.substring(2);
      try {
        const parsed = JSON.parse(val);
        if (typeof parsed === "string") currentAnswer += parsed;
      } catch {
        // Partial chunk, skip
      }
    }
  };

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop() || "";

    for (const line of lines) {
      processLine(line);
    }

    setChatMessages((prev) => {
      const updated = [...prev];
      const last = updated.length - 1;
      if (updated[last]?.sender !== "bot") return updated;

      if (!startedStreaming) {
        startedStreaming = true;
        updated[last] = {
          sender: "bot",
          text: currentAnswer,
          contextArray,
          isDone: false,
          isTyping: false,
        };
      } else {
        updated[last] = {
          ...updated[last],
          text: currentAnswer,
          contextArray:
            contextArray.length > 0 ? contextArray : updated[last].contextArray,
          isDone: false,
          isTyping: false,
        };
      }
      return updated;
    });
  }

  // Process remaining buffer
  if (buffer.trim()) processLine(buffer);

  // Finalize the message
  setChatMessages((prev) => {
    const updated = [...prev];
    const last = updated.length - 1;
    if (updated[last]?.sender === "bot") {
      updated[last] = {
        ...updated[last],
        text: currentAnswer,
        isDone: true,
        isTyping: false,
      };
    }
    return updated;
  });
}
